import React, { Component } from 'react';
import { history } from '../../helpers/history';
import SaayaLogo from '../../static/images/saayalogo.png';
import AlfalahLogo from '../../static/images/alfalahlogo.png';
import PakQatarLogo from '../../static/images/pakqatarlogo.png';
import defaultImage from '../../static/images/default_BG.png';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { constants } from '../../Constants';

class NotFound extends Component {
	redirectToHome = () => {
		history.replace('/home');
	};

	render() {
		const { whitelabel } = this.props;
		return (
			<div>
				<div className="container text-center w-100">
					<div className="notfound-logo">
						<img
							className="logo"
							src={whitelabel ? whitelabel[0].logo_url : defaultImage}
							alt="SaayaHealth logo"
						/>

						<div className="p-4">
							<h1 className="display-1">{constants.ERROR404_TXT}</h1>
							<h2 className="h3">{constants.PAGE_NOT_FOUND_TXT}</h2>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
function mapStateToProps(state) {
	const { alert } = state;
	const { registering } = state.reg;
	const { whitelabel } = state.whitelabel;
	return {
		alert,
		registering,
		whitelabel,
	};
}

export default withRouter(connect(mapStateToProps)(NotFound));




// WEBPACK FOOTER //
// ./src/components/Not Found/index.js